var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolFreehandPolygon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 1.5,
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m8.817 4.468 1.368-1.909M10.089 2.766l1.638-1.272M11.346 1.748l1.701-.668M12.777 1.112l1.575-.111M13.97.905l1.272.446M14.956 1.144l.906.954M15.767 1.939l.652 1.257M16.387 2.925l.143 1.368M16.594 3.832l-.398 1.813M16.276 5.199l-.652 2.068M15.767 6.726l-1.241 4.087M8.976 4.182l-.89.874M8.404 4.786l-.923.541M7.624 5.295l-.874.27M6.956 5.533l-1.526.462M5.573 5.963l-1.288.588M4.428 6.392 3.044 7.585M3.219 7.489 2.185 8.841M2.281 8.603l-.636 2.004M1.724 10.352l-.238 2.863M1.454 12.992l.222 1.384M1.517 14.153l.748 1.145M1.915 14.948l1.606 1.225M3.283 15.998l1.924.827M4.968 16.745l2.068.318M6.734 17.047l2.544-.159M8.992 16.984l1.67-.7M10.455 16.395l1.193-1.081M11.505 15.425l1.32-1.526M12.523 14.312l1.622-2.274M13.954 12.229l.652-1.638"
}), /*#__PURE__*/React.createElement("circle", {
  cy: 3.983,
  cx: 13.461,
  r: 1
}))));
export { SvgToolFreehandPolygon as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-freehand-polygon.svg";